import type { SiteControllerSetting_SettingPageQuery } from "@/lib/gql/__generated__/graphql";

import { useCreateSiteControllerSettingBaseFormModel } from "../use-create-model/use-create-model";

type Props = { data: SiteControllerSetting_SettingPageQuery };

export const useInitialized = ({ data }: Props) => {
	return {
		...useCreateSiteControllerSettingBaseFormModel({ serverModel: data }),
	};
};
